import React from 'react';
import { motion } from 'framer-motion';
import { Camera, Brain, ShieldCheck } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    id: '01',
    title: 'Scan',
    description: 'Point your camera at any ingredient label or upload a photo from your gallery.',
    icon: Camera,
    color: 'bg-blue-100 text-blue-600'
  }, {
    id: '02',
    title: 'Analyze',
    description: 'Our AI instantly identifies and categorizes every ingredient in seconds.',
    icon: Brain,
    color: 'bg-brand-100 text-brand-600'
  }, {
    id: '03',
    title: 'Decide',
    description: 'See which ingredients to avoid and make informed choices for your health.',
    icon: ShieldCheck,
    color: 'bg-accent-100 text-accent-600'
  }];
  return <section id="how-it-works" className="py-20 bg-white relative overflow-hidden" data-id="element-397">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-398">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-399">
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-400">
            How It Works
          </h2>
          <p className="text-lg text-slate-600" data-id="element-401">
            Three simple steps to healthier eating. No complex setup, just point
            and scan.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12" data-id="element-402">
          {steps.map((step, index) => <motion.div key={step.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative group" data-id="element-403">
              {/* Connector Line (Desktop only) */}
              {index !== steps.length - 1 && <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 border-t-2 border-dashed border-slate-200 -z-10" data-id="element-404" />}

              <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-405">
                <div className={`w-16 h-16 rounded-2xl ${step.color} flex items-center justify-center mb-6 mx-auto transform group-hover:scale-110 transition-transform duration-300`} data-id="element-406">
                  <step.icon className="w-8 h-8" data-id="element-407" />
                </div>

                <div className="text-center" data-id="element-408">
                  <span className="inline-block px-3 py-1 rounded-full bg-slate-100 text-slate-500 text-xs font-bold mb-4" data-id="element-409">
                    STEP {step.id}
                  </span>
                  <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-410">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-411">
                    {step.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}